import type { Duration, ToHumanDurationOptions } from 'luxon';
import type { NormalizeDurationProps } from './normalizeDuration';
import normalizeDuration from './normalizeDuration';

interface FormatAndNormalizeDurationProps extends NormalizeDurationProps {
  listStyle?: ToHumanDurationOptions['listStyle'];
}

/**
 * @name formatAndNormalizeDuration
 * @param start Start date
 * @param end End date (defaults to today)
 * @param top Number of top units to display, defaults to all
 * @param listStyle (optional) List style for human-readable duration
 * @return User-friendly duration normalized and rounded according to rules above or undefined if invalid
 * @throws Error if valid dates are passed but they couldn't be parsed
 */
const formatAndNormalizeDuration = ({
  listStyle = 'narrow',
  ...rest
}: FormatAndNormalizeDurationProps) => {
  let duration: Duration<true> | undefined;

  try {
    duration = normalizeDuration(rest);
  } catch (error) {
    // So we can investigate from our analytics provider later, but not throw
    // eslint-disable-next-line no-console
    console.error(error);
  }

  if (!duration) {
    return undefined;
  }

  return duration.toHuman({ listStyle });
};

export default formatAndNormalizeDuration;
